import { createContextualCan } from '@casl/react';
import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { useAuthStore } from '@/store/auth';
import { buildAbility, type AppAbility } from './ability';

const AbilityContext = createContext<AppAbility | null>(null);

export function AbilityProvider({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);
  // buildAbility is sync and cheap; re-runs only when user identity changes.
  const ability = useMemo(() => buildAbility(user), [user]);
  return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>;
}

export function useAbility(): AppAbility {
  const ability = useContext(AbilityContext);
  if (!ability) throw new Error('useAbility must be used inside <AbilityProvider>');
  return ability;
}

export const Can = createContextualCan<AppAbility>(AbilityContext.Consumer as never);
